export type RuntimeConfig = {
  apiUrl?: string;
  dashboardUrl?: string;
  stdUrl?: string;
  clientAppUrl?: string;
};

let runtimeConfig: RuntimeConfig = {};

export const setRuntimeConfig = (config: RuntimeConfig) => {
  runtimeConfig = config ?? {};
};

export const getRuntimeConfig = () => runtimeConfig;

export const loadRuntimeConfig = async (paths: string | string[]): Promise<void> => {
  const candidates = Array.isArray(paths) ? paths : [paths];
  const finalCandidate = candidates[candidates.length - 1];

  for (const path of candidates) {
    try {
      const response = await fetch(path, { cache: 'no-store' });
      if (!response.ok) {
        continue;
      }

      const data = (await response.json()) as RuntimeConfig;
      setRuntimeConfig(data);
      return;
    } catch (error) {
      if (path === finalCandidate) {
        console.warn('Runtime config load failed', error);
      }
    }
  }
};
